import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <footer className="py-8 px-4 bg-[#2E2E2E] text-white" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        {/* Links */}
        <div className="flex justify-center gap-4 text-sm mb-4" data-id="element-67">
          <button onClick={() => setActiveModal('terms')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-68">
            Términos y Condiciones
          </button>
          <span className="text-white/30" data-id="element-69">|</span>
          <button onClick={() => setActiveModal('privacy')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2" data-id="element-70">
            Política de Privacidad
          </button>
        </div>

        {/* Copyright */}
        <div className="text-center" data-id="element-71">
          <p className="text-white/40 text-xs" data-id="element-72">
            © {currentYear} 30 Cenas Anti-Pelea. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-73">
        <div className="space-y-4 text-[#2E2E2E]/80" data-id="element-74">
          <p data-id="element-75">
            <strong data-id="element-76">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-77">
            1. Información que recopilamos
          </h3>
          <p data-id="element-78">
            Recopilamos únicamente la información necesaria para procesar tu
            compra y enviarte el producto digital, incluyendo:
          </p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-79">
            <li data-id="element-80">Nombre y apellido</li>
            <li data-id="element-81">Dirección de correo electrónico</li>
            <li data-id="element-82">
              Información de pago (procesada de forma segura por terceros)
            </li>
          </ul>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-83">
            2. Uso de la información
          </h3>
          <p data-id="element-84">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-85">
            <li data-id="element-86">Procesar y entregar tu compra</li>
            <li data-id="element-87">Enviarte el producto digital adquirido</li>
            <li data-id="element-88">Comunicarnos contigo sobre tu pedido</li>
          </ul>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-89">
            3. Protección de datos
          </h3>
          <p data-id="element-90">
            No compartimos tus datos con terceros, excepto con nuestro
            procesador de pagos para completar la transacción. Tu información de
            pago es procesada de forma segura y no almacenamos datos de tarjetas
            de crédito.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-91">4. Tus derechos</h3>
          <p data-id="element-92">
            Podés solicitar la eliminación de tus datos en cualquier momento
            contactándonos por email. También podés solicitar acceso a la
            información que tenemos sobre vos.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-93">5. Cookies</h3>
          <p data-id="element-94">
            Utilizamos cookies esenciales para el funcionamiento del sitio y
            cookies de análisis para mejorar tu experiencia.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-95">
        <div className="space-y-4 text-[#2E2E2E]/80" data-id="element-96">
          <p data-id="element-97">
            <strong data-id="element-98">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-99">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-100">
            Al comprar este producto digital, aceptás estos términos y
            condiciones en su totalidad. Si no estás de acuerdo, no realices la
            compra.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-101">2. Producto digital</h3>
          <p data-id="element-102">
            El producto "30 Cenas Anti-Pelea" es un archivo PDF de descarga
            inmediata. Una vez realizada la compra, recibirás acceso al material
            a través del correo electrónico proporcionado.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-103">3. Uso permitido</h3>
          <p data-id="element-104">
            El contenido es para uso personal y familiar únicamente. Queda
            prohibido:
          </p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-105">
            <li data-id="element-106">Redistribuir el material de forma gratuita o paga</li>
            <li data-id="element-107">Revender el producto</li>
            <li data-id="element-108">Compartir el archivo con terceros</li>
            <li data-id="element-109">Modificar o crear obras derivadas</li>
          </ul>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-110">4. Disclaimer</h3>
          <p data-id="element-111">
            Este material es educativo y no constituye asesoramiento médico o
            nutricional profesional. Si hay alergias, intolerancias o
            condiciones médicas, consultá con un profesional de la salud antes
            de implementar las recetas.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-112">
            5. Garantía de devolución
          </h3>
          <p data-id="element-113">
            Ofrecemos una garantía de 7 días. Si no estás satisfecho/a con el
            producto, podés solicitar el reembolso completo dentro de los 7 días
            posteriores a la compra.
          </p>

          <h3 className="font-bold text-[#2E2E2E] mt-6" data-id="element-114">
            6. Propiedad intelectual
          </h3>
          <p data-id="element-115">
            Todo el contenido, incluyendo textos, recetas, diseños y materiales,
            está protegido por derechos de autor. © {currentYear} 30 Cenas
            Anti-Pelea.
          </p>
        </div>
      </Modal>
    </footer>;
}